// extracted by mini-css-extract-plugin
export default {"modalWrap":"styles_modalWrap__P4moV"};